/**
 * ============================================================
 * MONTE HERMOM - SISTEMA PGLP
 * Rotas de Laudos com 6 abas + Central de Vistorias
 * VERSÃO: 2.0.0
 * ------------------------------------------------------------
 * NOVIDADES v2.0.0:
 *   ✔ Guard de sessão instalado (sessaoGuard)
 *   ✔ Overlay de sessão expirada no topo
 *   ✔ Corrigida duplicação de App() e export default
 * ============================================================
 */

// ⚠️ CRÍTICO: precisa vir ANTES de qualquer outro import
import './services/sessaoGuard';

import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';

// Provedores
import { AuthSaaSProvider } from './context/AuthSaaSContext';
import { PrivateRoute } from './components/auth/PrivateRoute';

// Overlay de sessão expirada
import SessaoExpiradaOverlay from './components/SessaoExpiradaOverlay';

// Auth
import AuthAcesso_2FA_Logic from './components/auth/AuthAcesso_2FA_Logic';

// Dashboard
import IndexDashboard from './components/dashboard/index_Dashboard';

// Laudos
import CentralLaudos from './components/laudo/CentralLaudos';
import NovoLaudo from './components/laudo/NovoLaudo';
import LaudoLayout from './components/laudo/LaudoLayout';

// Abas do laudo
import ImovelForm from './components/imovel/ImovelForm';
import AbaAbertura from './components/laudo/abas/AbaAbertura';
import NovaVistoria from './components/Vistoria/NovaVistoria';
import ImovelParadigma_Amostras from './components/imovel/ImovelParadigma_Amostras';
import LaudoConsolidador_soberano from './components/laudo/LaudoConsolidador_soberano';
import LaudoRevisaoNarrativa_Soberana from './components/laudo/LaudoRevisaoNarrativa_Soberana';
import LaudoFechamento_lacre from './components/laudo/LaudoFechamento_lacre';

// Vistorias (fora do laudo)
import CentralVistorias from './components/Vistoria/CentralVistorias';
import NovaVistoriaStandalone from './components/Vistoria/NovaVistoriaStandalone';
import VistoriaStandalone from './components/Vistoria/VistoriaStandalone';

function App() {
  return (
    <HelmetProvider>
      <AuthSaaSProvider>
        <div className="min-h-screen bg-[#050810] font-sans antialiased text-slate-200">
          <Helmet>
            <title>PGLP | MONTE HERMOM</title>
          </Helmet>

          <Router>
            {/* ============================================
                OVERLAY DE SESSÃO EXPIRADA
                (cobre toda a tela quando a sessão cai)
            ============================================ */}
            <SessaoExpiradaOverlay />

            <Suspense
              fallback={
                <div className="flex items-center justify-center h-screen bg-[#050810] text-white font-black italic">
                  CARREGANDO CÚPULA...
                </div>
              }
            >
              <Routes>

                {/* ---------- 2FA ---------- */}
                <Route path="/validacao-2fa" element={<AuthAcesso_2FA_Logic />} />

                {/* ---------- DASHBOARD ---------- */}
                <Route
                  path="/dashboard"
                  element={<PrivateRoute><IndexDashboard /></PrivateRoute>}
                />

                {/* ---------- LAUDOS — LISTA ---------- */}
                <Route
                  path="/laudos"
                  element={<PrivateRoute><CentralLaudos /></PrivateRoute>}
                />

                {/* ---------- LAUDOS — NOVO (wizard) ---------- */}
                <Route
                  path="/laudos/novo"
                  element={<PrivateRoute><NovoLaudo /></PrivateRoute>}
                />

                {/* ---------- LAUDOS — ABAS (6 fases) ---------- */}
                <Route
                  path="/laudos/:codigo"
                  element={<PrivateRoute><LaudoLayout /></PrivateRoute>}
                >
                  <Route index element={<Navigate to="abertura" replace />} />
                  <Route path="abertura"    element={<AbaAbertura />} />
                  <Route path="imovel/novo" element={<ImovelForm />} />
                  <Route path="vistoria"    element={<NovaVistoria />} />
                  <Route path="amostras"    element={<ImovelParadigma_Amostras />} />
                  <Route path="analise"     element={<LaudoConsolidador_soberano />} />
                  <Route path="revisao"     element={<LaudoRevisaoNarrativa_Soberana />} />
                  <Route path="finalizacao" element={<LaudoFechamento_lacre />} />
                </Route>

                {/* ---------- VISTORIAS (agenda fora do laudo) ---------- */}
                <Route
                  path="/vistorias"
                  element={<PrivateRoute><CentralVistorias /></PrivateRoute>}
                />
                <Route
                  path="/vistorias/nova"
                  element={<PrivateRoute><NovaVistoriaStandalone /></PrivateRoute>}
                />
                <Route
                  path="/vistorias/:id"
                  element={<PrivateRoute><VistoriaStandalone /></PrivateRoute>}
                />

                {/* ---------- REDIRECIONAMENTOS ---------- */}
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />

              </Routes>
            </Suspense>
          </Router>

          {/* Marca d'água */}
          <div className="fixed bottom-6 left-8 pointer-events-none opacity-30 z-50">
            <div className="flex flex-col gap-1">
              <span className="text-[9px] font-black text-slate-400 uppercase tracking-[0.3em]">
                Soberania Digital © 2026
              </span>
              <span className="text-[7px] font-black text-slate-600 uppercase tracking-widest">
                Marcus Ferraz Identity | NBR 14653-2 Compliance
              </span>
            </div>
          </div>
        </div>
      </AuthSaaSProvider>
    </HelmetProvider>
  );
}

export default App;